import Navigation from '@package/components/theme/Navigation/Navigation';

export default Navigation;
